<template>
  <div :class="$store.getters.platform === 'browser' ? 'page-bg-browser' : 'page-bg'" v-bg="{image: category.background, alternative: true, dir: 'to right'}">

    <app-loader v-if="loading"></app-loader>
    <div v-else>

        <!-- content category -->
        <div class="valign-wrapper wrapper-list" style="overflow: hidden;">
          <app-list
            :options="{
              id: 'cat-' + category.id,
              type: listType,
              title: category.name,
              items: items,
              route: listRoute,
              card: category.card,
              wrapper: $el
            }"
          />
        </div>

    </div>
  </div>
</template>

<script>
import Bus from '@/components/ControlBus'
import Loader from '@/components/Loader'
import List from '@/components/List'
import {StatsProductCategory} from '@/utils/constants'
const productsService = require('@/services/products.js')

export default {
  name: 'ProductCategory',
  components: {
    'app-loader': Loader,
    'app-list': List
  },
  data () {
    return {
      category: {},
      items: []
    }
  },
  beforeCreate: function () {
    document.querySelector('body').style.overflowY = 'hidden'
  },
  created: function () {
    // CATEGORÍA
    if (this.$store.getters.getData.type_shop === 'A2C') {
      // TIENDA A2C
      let categories = this.$store.getters.shopCategories

      if (categories.length) {
        // categorias desde memoria
        let category = categories.filter(item => { return item.id === this.$route.params.id })[0]
        let cat = {
          id: category.id,
          name: category.name
        }

        let childs = categories.filter(item => { return item.parent_id === cat.id })
        let items = []

        if (childs.length) {
          cat.is_final = false

          // subcategorías
          for (let i = 0; i < childs.length; i++) {
            let img = childs[i].images.length ? childs[i].images[0].http_path : ''
            items.push({
              id: childs[i].id,
              name: childs[i].name,
              image: img
            })
          }

          setTimeout(() => {
            this.items = items
            this.category = cat
          }, 0)

          // stats category
          window.Countly.q.push(['track_pageview', StatsProductCategory + ' ' + this.category.id + ': ' + this.category.name])
        } else {
          cat.is_final = true

          productsService.productsA2C({category_id: cat.id}).then(response => {
            for (let i = 0; i < response.data.product.length; i++) {
              let img = response.data.product[i].images.filter((a) => (a.type === 'IMAGE_TYPE_BASE'))[0]

              items.push({
                id: response.data.product[i].id,
                name: response.data.product[i].name,
                image: img.http_path
              })
            }

            this.items = items
            this.category = cat

            // stats category
            window.Countly.q.push(['track_pageview', StatsProductCategory + ' ' + this.category.id + ': ' + this.category.name])
          })
        }
      } else {
        // categorias desde server
        productsService.categoriesA2C({id: this.$route.params.id}).then(response => {
          let category = {
            id: response.data.id,
            name: response.data.name
          }

          productsService.categoriesA2C({parent_id: response.data.id}).then(response => {
            let items = []
            if (response.data.category.length) {
              category.is_final = false

              for (let i = 0; i < response.data.category.length; i++) {
                items.push({
                  id: response.data.category[i].id,
                  name: response.data.category[i].name,
                  image: response.data.category[i].http_path
                })
              }

              this.items = items
              this.category = category

              // stats category
              window.Countly.q.push(['track_pageview', StatsProductCategory + ' ' + this.category.id + ': ' + this.category.name])
            } else {
              category.is_final = true

              productsService.productsA2C({category_id: category.id}).then(response => {
                for (let i = 0; i < response.data.product.length; i++) {
                  let img = response.data.product[i].images.filter((a) => (a.type === 'IMAGE_TYPE_BASE'))[0]

                  items.push({
                    id: response.data.product[i].id,
                    name: response.data.product[i].name,
                    image: img.http_path
                  })
                }

                this.items = items
                this.category = category

                // stats category
                window.Countly.q.push(['track_pageview', StatsProductCategory + ' ' + this.category.id + ': ' + this.category.name])
              })
            }
          })
        })
      }
    } else {
      productsService.getCategory(this.$route.params.id).then(response => {
        // NO TIENDA A2C
        this.category = response.data

        // mostramos categoría
        !this.category.is_final ? this.items = this.category.child_categories : this.items = this.category.category_product
        // stats category
        window.Countly.q.push(['track_pageview', StatsProductCategory + ' ' + this.category.id + ': ' + this.category.name])
      })
    }
  },
  mounted: function () {
    // control keys
    Bus.$on('key-back', this.keyBack)
  },
  methods: {
    keyBack: function () { this.$router.go(-1) }
  },
  computed: {
    loading: function () {
      return Object.keys(this.category).length === 0
    },
    listType: function () {
      let type = ''
      !this.category.is_final ? type = 'card-categories-products' : type = 'card-products'
      return type
    },
    listRoute: function () {
      let route = ''
      !this.category.is_final ? route = 'shop-category' : route = 'shop-product'
      return route
    }
  },
  beforeDestroy: function () {
    Bus.$off('key-back', this.keyBack)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
.wrapper-list
  position: relative;
  height: 100vh;
</style>



// WEBPACK FOOTER //
// src/pages/products/ProductCategory.vue